<template>
  <div v-if="mode">
    <comment :element-uuid="element.uuid" :submission-uuid="main_sid" />
    <fb-likert-view @change="updateValue" :checkbox="saveData" :valid="valid" :validate="validate" :nid="nid"/>
  </div>
  <md-card v-else class="md-elevation-2 md-layout-item">
    <fb-controll
      :controll="saveData.label || 'Likert'"
      @setting-click="showSettings"
      @collapse-click="collapsePreview"
      @menu-delete="$emit('menu-delete')"
    />
    <md-content v-show="!collapse">
      <fb-likert-view :checkbox="saveData"/>
    </md-content>
    <md-dialog :md-active.sync="showDialog" md-dynamic-height>
      <md-dialog-title>Settings</md-dialog-title>
      <md-dialog-content>
        <md-field>
          <label>Label</label>
          <md-input v-model="tempData.label"></md-input>
        </md-field>
        <fb-likert-option
          @save="save"
          @save-option="saveOptions('options', $event)"
          :options="tempData.options"
        />
        <fb-likert-section
          @save="save"
          @save-option="saveOptions('sections', $event)"
          :options="tempData.sections"
        />
        <md-checkbox v-model="tempData.required">Required</md-checkbox>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="cancel">Close</md-button>
        <md-button class="md-primary" @click="save">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </md-card>
</template>

<script>
import FbElementMixin from "../FbElementMixin";
import FbLikertOption from "./FbLikertOption";
import FbLikertSection from "./FbLikertSection";
import FbLikertView from "./FbLikertView";

export default {
  name: "FbLikert",
  props: ["element", "mode", "validate"],
  mixins: [FbElementMixin],
  created() {
    if (
      this.sid &&
      this.sid != "" &&
      window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
        this.element.uuid
      ]
    ) {
      this.saveData.value =
        window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
          this.element.uuid
        ].value;
      this.$emit("set-value", this.value);
    }
    this.$emit("validation", this.valid);
  },
  computed: {
    messageClass() {
      return {
        "md-invalid": !this.valid && this.validate === true
      };
    },
    valid() {
      if (this.isDraft) {
        return true;
      }
      let val;
      if (this.saveData.required === true) {
        val = false;
        for (let key in this.saveData.value) {
          if (this.saveData.value[key] && this.saveData.value[key] != "") {
            val = true;
            break;
          }
        }
      } else {
        val = true;
      }
      return val;
    }
  },
  data() {
    return {
      showDialog: false,
      tempData: {
        label: this.element.data.label || "",
        options: this.element.data.options.slice(0) || [],
        sections: this.element.data.sections || [],
        required: this.element.data.required || false
      },
      saveData: {
        label: this.element.data.label || "",
        options: this.element.data.options.slice(0) || [],
        sections: this.element.data.sections || [],
        required: this.element.data.required || false,
        value: {}
      }
    };
  },
  components: {
    FbLikertOption,
    FbLikertView,
    FbLikertSection
  },
  methods: {
    saveOptions: function saveOptions(type, data) {
      this.tempData[type] = data;
    },
    updateValue(val) {
      this.saveData.value = val;
      this.$emit("validation", this.valid);
      this.$emit("set-value", this.value);
    }
  }
};
</script>

<style scoped>
.md-dialog-content::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}
.md-dialog-content::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
</style>
